<script>
// Tile burro da PALETA do editor de personalização (módulos ocultos): um
// quadrado só com o ícone do módulo, rótulo só no tooltip nativo
// (`title`/`aria-label`) — a fileira "ADICIONAR MÓDULO" é compacta e não
// cabe texto ao lado do ícone. O canvas (módulos visíveis) NÃO usa este
// tile: ele desenha o card REAL (`IaInsightCard`, mesma altura/estrutura de
// produção — pedido do usuário) direto em `personalizacao-canvas.vue`.
export default {
  name: 'PersonalizacaoItemTile',
  props: {
    id: {
      type: String,
      required: true,
    },
    rotulo: {
      type: String,
      required: true,
    },
    icone: {
      type: String,
      required: true,
    },
  },
}
</script>

<template>
  <div
    class="personalizacao-item-tile"
    :title="rotulo"
    :aria-label="rotulo"
  >
    <icon-svg :name="icone" :size="18" color="muted" />
  </div>
</template>

<style lang="sass" scoped>
.personalizacao-item-tile
  display: flex
  align-items: center
  justify-content: center
  width: 36px
  height: 36px
  // `--neutral-300`, não `--border-hairline`: a hairline (#ECECEF) tem a
  // MESMA cor da faixa da paleta por trás (~#ED) e sumia — o tile ficava
  // sem borda nenhuma (achado do usuário). Mesmo tom da moldura pontilhada
  // dos cards do canvas.
  border: 1px solid var(--neutral-300)
  border-radius: var(--radius-sm)
  // Sem fundo próprio (decisão do usuário): o tile herda a faixa da paleta
  // por trás — só a borda o desenha.
  background: transparent
  flex-shrink: 0
  cursor: grab

  &:hover
    background: var(--sidebar-warm-hover)

  &:active
    cursor: grabbing
</style>
